import React, { useCallback } from 'react';
import { StyledNumericInput } from '../StyledComponent';

const FloatInput = React.forwardRef(({ value, onChange: inputOnChange, className, ...rest }, ref) => {
  const onChange = useCallback(
    (e) => {
      inputOnChange(typeof e.floatValue === 'number' ? e.floatValue : null);
    },
    [inputOnChange],
  );

  return (
    <StyledNumericInput
      getInputRef={ref}
      decimalScale={2}
      thousandSeparator
      value={value ?? ''}
      onValueChange={onChange}
      type="text"
      dir="ltr"
      className={className}
      {...rest}
    />
  );
});

export default React.memo(FloatInput);
